define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MPastureQualityDomain = void 0;
    class MPastureQualityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MPastureQualityDomain.PerennialVulnerable, value: "Perennial Vulnerable" },
                    { key: MPastureQualityDomain.Dead, value: "Dead" },
                    { key: MPastureQualityDomain.Dry, value: "Dry" },
                    { key: MPastureQualityDomain.Green, value: "Green" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MPastureQualityDomain.PerennialVulnerable] = 0;
                this.KeyIndex[MPastureQualityDomain.Dead] = 1;
                this.KeyIndex[MPastureQualityDomain.Dry] = 2;
                this.KeyIndex[MPastureQualityDomain.Green] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Perennial Vulnerable"] = 0;
                this.ValueIndex["Dead"] = 1;
                this.ValueIndex["Dry"] = 2;
                this.ValueIndex["Green"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MPastureQualityDomain = MPastureQualityDomain;
    Object.defineProperty(MPastureQualityDomain, "PerennialVulnerable", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MPastureQualityDomain, "Dead", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MPastureQualityDomain, "Dry", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MPastureQualityDomain, "Green", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MPastureQualityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
